/**
 * Researches that share an anchor research's questionnaire, anchor excluded.
 * Two researches can only be combined when they use the same questionnaire,
 * so the merge UI offers exactly these. Pure function — no Firebase imports.
 *
 * @param {Array<{ID: string, QuestionnaireID?: string}>} allResearch - All researches of the tenant
 * @param {{ID: string, QuestionnaireID?: string}} anchor - The anchor research
 * @returns {Array<{ID: string, QuestionnaireID?: string}>} Researches sharing the questionnaire, without the anchor
 */
const researchSharingQuestionnaire = (allResearch, anchor) => {
    const questionnaireId = anchor?.QuestionnaireID
    if (!questionnaireId) return []
    return (Array.isArray(allResearch) ? allResearch : [])
        .filter((r) => r.ID !== anchor.ID && r.QuestionnaireID === questionnaireId)
}

export default researchSharingQuestionnaire
